import Cookies from "js-cookie"
import {connect} from "react-redux"
import State from "../../ducks/state"
import {typing, search, openDrawer, showRecentSearch} from "../../ducks/search"
import {createRecentQuery} from "../../ducks/recents"
import {getAutoCompleteThunk, BR_UID_2, clearSuggestions, setIsLoading} from "../../ducks/autocomplete"
import {getCookieValue} from "../../utils/cookies"
import urls from "../../config/urls"
import {PublishToModalsClosed} from "../../events/modalsClosed"
import {MIN_NUMBER_CHAR_TO_SHOW_AUTOCOMPLETE} from "../../config/constants"

export const mapStateToProps = (state: State, ownProps) => {
    const autocompleteParameters = state.autocomplete.parameters
    const cookie = state.request?.headers?.cookie
    const realm = state.data?.realm.toLowerCase() as string
    const {variant, iconsVersionPath, xxlBreakpointEnabled} = state.settings
    const {
        text: {searchBox},
        template,
        request: {siteUrl, cleanSiteUrl},
        settings: {isTpSuperLite},
    } = state
    const {territory} = autocompleteParameters

    return {
        text: searchBox,
        cookie,
        autocompleteParameters,
        backgroundImage: urls.searchBox.searchInputButtonUrl(realm, variant, iconsVersionPath),
        siteUrl,
        cleanSiteUrl,
        typedCharacters: state.search.typedCharacters,
        templating: template,
        autocompleteTerritory: territory,
        xxlBreakpointEnabled,
        isTpSuperLite,
        clearIconUrl: urls.searchBox.clearButtonRealmSpecific(realm, variant, iconsVersionPath),
    }
}

// stateProps is the result of mapStateToProps
// {dispatch}  is the object resultingfrom mapDispatchToProps
// ownProps is the container component own props
export const mergeProps = (stateProps: any, {dispatch}: any, ownProps: any) => {
    return {
        ...stateProps,
        dispatch,
        ...ownProps,
        handleSubmit: (searchTerm: string) => {
            const {siteUrl, cleanSiteUrl, isTpSuperLite} = stateProps
            dispatch(createRecentQuery(searchTerm))
            dispatch(search(isTpSuperLite ? cleanSiteUrl : siteUrl, searchTerm))
            dispatch(showRecentSearch(false))
        },
        typing: (chars: string) => {
            dispatch(typing(chars))
            if (chars && chars.length >= MIN_NUMBER_CHAR_TO_SHOW_AUTOCOMPLETE) {
                dispatch(clearSuggestions())
            }
        },
        autocompleteTyping: (chars: string) => {
            const {territory} = stateProps.autocompleteParameters
            const {cookie} = stateProps
            const uid2 = cookie ? getCookieValue(BR_UID_2, cookie) : Cookies.get(BR_UID_2)
            dispatch(getAutoCompleteThunk(chars, uid2, territory))
        },
        openDrawer: () => {
            PublishToModalsClosed()
            return dispatch(openDrawer())
        },
        setAutoCompleteIsLoading: () => {
            dispatch(setIsLoading(true))
        },
    }
}

export const mapDispatchToProps = dispatch => ({
    handleSubmit: (searchTerm: string, siteUrl: string) => {
        dispatch(createRecentQuery(searchTerm))
        dispatch(search(siteUrl, searchTerm))
        dispatch(showRecentSearch(false))
    },
    typing: (chars: string) => {
        dispatch(typing(chars))
        if (chars && chars.length >= MIN_NUMBER_CHAR_TO_SHOW_AUTOCOMPLETE) {
            dispatch(clearSuggestions())
        }
    },
    autocompleteTyping: ({chars, territory, cookie}: {chars: string; territory: string; cookie?: string}) => {
        const uid2 = cookie ? getCookieValue(BR_UID_2, cookie) : Cookies.get(BR_UID_2)
        dispatch(getAutoCompleteThunk(chars, uid2, territory))
    },
    openDrawer: () => {
        PublishToModalsClosed()
        return dispatch(openDrawer())
    },
    setAutoCompleteIsLoading: () => {
        dispatch(setIsLoading(true))
    },
    dispatch,
})

export default connect(mapStateToProps, mapDispatchToProps)
